/**
 * @author Nicolas Knop <nicolas.knop@wendweb.de>
 * @description Slick slider configuration with custom behavior
 */
(function (window, $, undefined) {

	'use strict';

	var document = window.document;
	var $document = $(document);
	var DATA_HTML = 'data-html';
	var DATA_SITEHEADER = 'data-siteheader';
	var DATA_SITECONTENT = 'data-sitecontent';
	var DATA_ARTICLE = 'data-article';
	var DATA_ARTICLE_EXPAND = 'data-article-expand';
	var DATA_ARTICLE_CLOSE_CONTEXT = 'data-article-close-context';
	var DATA_ARTICLE_BUTTON = 'data-article-button';
	var DATA_FILTER = 'data-filter';
	var DATA_FILTER_HEAD = 'data-filter-head';
	var DATA_FILTER_INDEX = 'data-filter-index';
	var DATA_FILTER_INPUT = 'data-filter-input';
	var DATA_FILTER_RESULTS = 'data-filter-results';
	var DATA_FILTER_SUBFILTER = 'data-filter-subfilter';
	var DATA_CHANGE_FILTER = 'data-change-filter';
	var DATA_PRODUCTGROUP = 'data-productgroup';
	var DATA_PRODUCTGROUP_ITEM = 'data-productgroup-item';
	var DATA_PRODUCT_SWITCH = 'data-product-switch';
	var DATA_PRODUCT_INDEX = 'data-product-index';
	var DATA_SLIDER = 'data-slider';
	var DATA_SLIDER_INNER = 'data-slider-inner';
	var DATA_SLIDER_BUTTON_NEXT = 'data-slider-button-next';
	var DATA_SLIDER_BUTTON_PREV = 'data-slider-button-prev';
	var DATA_STICKY = 'data-sticky';
	var DATA_VIDEOWRAP = 'data-videowrap';
	var DATA_VIDEOCLOSE = 'data-videoclose';
	var DATA_VIDEO_PLAYER = 'data-video-player';
	var DATA_VIDEO_BUTTON = 'data-video-button';
	var active = 'active';
	var fixed = 'fixed';
	var indented = 'indented';
	var checked = ':checked';
	var html = 'html, body';
	var isScrolling = false;
	var lastScrollEvent = null;
	var interval;
	var scrollDiff = 0;
	var lastScrollTop = $document.scrollTop();
	var STICKY_ACTIVATER = 200;
	var DATA_VIDEOWRAP_STAGE = 'data-videowrap-stage';
	var DATA_VIDEOCLOSE_STAGE = 'data-videoclose-stage';
	var DATA_VIDEO_BUTTON_STAGE = 'data-video-button-stage';

	$(init);

	function init () {
		onSectionButtonClick();
		onFilterInputChange();
		onProductSwitchChange();
		onSlickInit();
		initSlider();
		onAnchorClick();
		startInverval();
		onVideoClick();
		onVideoCloseClick();
		onVideoEscape();
		onSliderNextClick();
		onSliderPrevClick();
		onSlickNextEvent();
		onSetFilterClick();
		initFilter();
		urlCheck();
		onStageVideoClick();
		onVideoStageCloseClick();
		onVideoStageEscape();


		window.addEventListener('scroll', function (event) {
			isScrolling = true;
			lastScrollEvent = event;
		});

		// Play video if GET-Parameter exists
		var field = 'playvideo';
		var url = window.location.href;

		if (url.indexOf('?' + field + '=') != -1) {
			$('[' + DATA_VIDEO_BUTTON + ']').click();
		}
		else if (url.indexOf('&' + field + '=') != -1) {
			$('[' + DATA_VIDEO_BUTTON + ']').click();
		}
	}

	function urlCheck () {
		$(window).on('load', function () {
			var urlAnchor = window.location.hash;
			var fields = ['#Preisvergleich350', '#preisvergleich350', '#Preisvergleich290', '#preisvergleich290'];

			fields.forEach(function (element) {
				if (element.indexOf(fields)) {
					if (element === urlAnchor) {

						if (urlAnchor.indexOf('350') >= 0) {
							setFilter('child', '350g');
						} else if (urlAnchor.indexOf('290') >= 0) {
							setFilter('child', '290g');
						}

						$(html).animate({
							scrollTop: $('#preisvergleich').offset().top
						}, 250);
					}
				}
			});
		});
	}

	function startInverval () {

		interval = setInterval(function () {
			if (isScrolling) {
				isScrolling = false;
				onDocumentScroll(lastScrollEvent);
			}
		}, 100);
	}

	function onSectionButtonClick () {
		$('[' + DATA_ARTICLE_BUTTON + ']').on('click', function () {
			var $self = $(this);
			var $article = $self.closest($('[' + DATA_ARTICLE + ']'));

			if ($self.hasClass(active)) {
				closeArticle($article);
			} else {
				openArticle($article);
			}
		});
	}

	function onFilterInputChange () {
		$('[' + DATA_FILTER_INPUT + ']').on('change', function () {
			var $results;
			var $self = $(this);
			var $filter = $self.closest($('[' + DATA_FILTER + ']'));
			var filterCategory = $self.attr(DATA_FILTER_INPUT);
			var filterIndex = $self.attr(DATA_FILTER_INDEX);

			if ($self.is(checked)) {
				if (filterCategory !== undefined) {
					$filter.find('[' + DATA_FILTER_SUBFILTER + ']').removeClass(active);
					$filter.find('[' + DATA_FILTER_SUBFILTER + '=' + filterCategory + ']').addClass(active);
					$filter.find('[' + DATA_FILTER_RESULTS + ']').removeClass(active);
					$filter.find('[' + DATA_FILTER_RESULTS + '=' + filterCategory + ']').addClass(active);
				}
				if (filterIndex !== undefined) {
					$results = $filter.find('[' + DATA_FILTER_RESULTS + '=' + filterCategory + ']');
					$results.find('[' + DATA_FILTER_INDEX + ']').removeClass(active);
					$results.find('[' + DATA_FILTER_INDEX + '=' + filterIndex + ']').addClass(active);
				}
			}
		});
	}

	function onProductSwitchChange () {
		$('[' + DATA_PRODUCT_SWITCH + ']').on('change', function () {

			var $self = $(this);
			var $wrapper = $self.closest($('[' + DATA_PRODUCTGROUP + ']'));
			var $item = $wrapper.find($('[' + DATA_PRODUCTGROUP_ITEM + ']'));
			var isChecked = $self.is(checked);

			$item.each(function () {
				var $self = $(this);
				var $productIndex = $self.find($('[' + DATA_PRODUCT_INDEX + ']'));
				$self.find($('[' + DATA_PRODUCT_SWITCH + ']')).prop('checked', isChecked);
				$($productIndex[isChecked ? 0 : 1]).addClass(active);
				$($productIndex[isChecked ? 1 : 0]).removeClass(active);
			});
		});
	}

	function openArticle ($article) {
		var $articleExpand = $article.find($('[' + DATA_ARTICLE_EXPAND + ']'));
		var expandHeight = $articleExpand[0].scrollHeight + 1;

		$article.find($('[' + DATA_ARTICLE_BUTTON + ']')).addClass(active);
		$articleExpand.css('max-height', expandHeight + 'px');
		scrollToPosition($articleExpand);
	}

	function closeArticle ($article) {
		var $articleExpand = $article.find($('[' + DATA_ARTICLE_EXPAND + ']'));
		var $articleCloseContext = $article.closest('[' + DATA_ARTICLE_CLOSE_CONTEXT + ']');

		if (!$articleCloseContext.length) {
			$articleCloseContext = $article.find('[' + DATA_ARTICLE_CLOSE_CONTEXT + ']');
		}

		$article.find($('[' + DATA_ARTICLE_BUTTON + ']')).removeClass(active);
		$articleExpand.removeAttr('style');
		scrollToPosition($articleCloseContext);
	}

	function onDocumentScroll () {
		var newScrollPosition = $document.scrollTop();

		if (newScrollPosition <= $('[' + DATA_HTML + ']')[0].clientHeight) {
			$('[' + DATA_SITEHEADER + ']').removeClass(active);
			$('[' + DATA_STICKY + ']').removeClass(active);
			setTimeout(function () {
				$('[' + DATA_SITEHEADER + ']').removeClass(fixed);
				$('[' + DATA_SITECONTENT + ']').removeClass(indented);
			}, 250);
			lastScrollTop = newScrollPosition;
			return;
		} else {

			$('[' + DATA_SITEHEADER + ']').addClass(fixed);
			$('[' + DATA_SITECONTENT + ']').addClass(indented);
		}

		var a = lastScrollTop - newScrollPosition;
		if (a <= 0) {
			scrollDiff = 0;
		} else {
			scrollDiff += Math.abs(a); //negativ scroll bottom, pos top
		}

		if (scrollDiff >= STICKY_ACTIVATER) {
			$('[' + DATA_SITEHEADER + ']').addClass(active);
			$('[' + DATA_STICKY + ']').addClass(active);
		} else {
			$('[' + DATA_SITEHEADER + ']').removeClass(active);
			$('[' + DATA_STICKY + ']').removeClass(active);
		}
		lastScrollTop = newScrollPosition;
	}

	function onVideoClick () {
		$('[' + DATA_VIDEO_BUTTON + ']').on('click', function (e) {
			$('[' + DATA_VIDEOWRAP + ']').addClass("show");

			var player = new Vimeo.Player($(".video__player"));
			player.play();
			player.on('ended', function () {
				$('[' + DATA_VIDEOWRAP + ']').removeClass("show");
			});

			return false;
		});
	}

	function onVideoCloseClick () {
		$('[' + DATA_VIDEOCLOSE + ']').on('click', function () {
			$('[' + DATA_VIDEOWRAP + ']').removeClass("show");

			var player = new Vimeo.Player($(".video__player"));
			player.pause();

			return false;
		});
	}

	function onStageVideoClick () {
		$('[' + DATA_VIDEO_BUTTON_STAGE + ']').on('click', function (e) {
			$('[' + DATA_VIDEOWRAP_STAGE + ']').addClass("show");

			var player = new Vimeo.Player($(".video__stage"));
			player.play();
			player.on('ended', function () {
				$('[' + DATA_VIDEOWRAP_STAGE + ']').removeClass("show");
			});

			return false;
		});
	}

	function onVideoStageCloseClick () {
		$('[' + DATA_VIDEOCLOSE_STAGE + ']').on('click', function () {
			$('[' + DATA_VIDEOWRAP_STAGE + ']').removeClass("show");

			var player = new Vimeo.Player($(".video__stage"));
			player.pause();

			return false;
		});
	}

	function onVideoStageEscape () {
		$(document).keydown(function (evt) {
			var isEscape = false;
			evt = evt || window.event;

			if ("key" in evt) {
				isEscape = (evt.key === "Escape" || evt.key === "Esc");
			} else {
				isEscape = (+evt.keyCode === 27);
			}

			if (isEscape) {
				$('[data-videoclose-stage]').click();
			}
		});
	}

	function onVideoEscape () {
		$(document).keydown(function (evt) {
			var isEscape = false;
			evt = evt || window.event;

			if ("key" in evt) {
				isEscape = (evt.key === "Escape" || evt.key === "Esc");
			} else {
				isEscape = (+evt.keyCode === 27);
			}

			if (isEscape) {
				$('[data-videoclose]').click();
			}
		});
	}

	function onSliderNextClick () {
		$('[' + DATA_SLIDER_BUTTON_NEXT + ']').on('click', function () {

			var $slider = $(this).closest('[' + DATA_SLIDER + ']');
			$slider.find('[' + DATA_SLIDER_INNER + ']').slick('slickNext');
		});
	}

	function onSliderPrevClick () {
		$('[' + DATA_SLIDER_BUTTON_PREV + ']').on('click', function () {

			var $slider = $(this).closest('[' + DATA_SLIDER + ']');
			$slider.find('[' + DATA_SLIDER_INNER + ']').slick('slickPrev');
		});
	}

	/**
	 * @description Init slick slider object with custom attributes
	 * @selector Slider body
	 */
	function initSlider () {
		$('[' + DATA_SLIDER_INNER + ']').slick({

			autoplay: false,
			arrows: false,
			centerMode: true,
			centerPadding: 0,
			draggable: true,
			infinite: false,
			initialSlide: 0,
			swipeToSlide: true,
			swipe: true,
			slidesToShow: 1,
			variableWidth: true
		});
	}

	function onSlickNextEvent () {

		$('[' + DATA_SLIDER_INNER + ']').on('afterChange', function (slick, currentSlide) {
			var $slider = $(this).closest('[' + DATA_SLIDER + ']');
			var $next = $slider.find('[' + DATA_SLIDER_BUTTON_NEXT + ']');
			var $prev = $slider.find('[' + DATA_SLIDER_BUTTON_PREV + ']');
			var slideCount = currentSlide.slideCount; // Count of all slides
			var slideIndex = currentSlide.currentSlide; // Current slide index

			if (slideIndex === (slideCount - 1)) {
				$next.prop("disabled", true);
			} else {
				$next.prop("disabled", false);
			}
			if (slideIndex === 0) {
				$prev.prop("disabled", true);
			} else {
				$prev.prop("disabled", false);
			}
		});
	}

	function onSlickInit () {
		$('[' + DATA_SLIDER_INNER + ']').on('init', function () {
			var $slide = $(this).closest('[' + DATA_SLIDER + ']');

			$slide.find('[' + DATA_SLIDER_BUTTON_PREV + ']').prop('disabled', true);
		});
	}

	function onAnchorClick () {
		$('a[href^="#"]').on('click', function (event) {
			var anchor, target;
			event.preventDefault();
			anchor = this.href.match(/#[a-zA-Z0-9-_]+/i);
			target = $(anchor[0]);
			scrollToPosition(target);
		});
	}

	function scrollToPosition (target) {
		if (target.length) {
			resetStickyHeader();
			$(html).animate({
				scrollTop: target.offset().top
			}, 1000);
			setTimeout(function () {
				startInverval();
			}, 1000);

		}
	}

	function resetStickyHeader () {
		clearInterval(interval);
		lastScrollTop = 0;
		scrollDiff = 0;
		$('[' + DATA_SITEHEADER + ']').removeClass(active);
		setTimeout(function () {
			$('[' + DATA_SITEHEADER + ']').removeClass(fixed);
			$('[' + DATA_SITECONTENT + ']').removeClass(indented);
		}, 250);
		$('[' + DATA_STICKY + ']').removeClass(active);
	}

	function onSetFilterClick () {

		$('[' + DATA_CHANGE_FILTER + ']').on('click', function () {

			var $self = $(this);
			var category = $self.attr(DATA_CHANGE_FILTER);
			var index = $self.attr(DATA_FILTER_INDEX);

			setFilter(category, index);
		});
	}

	function setFilter (category, index) {
		var $filter = $('[' + DATA_FILTER + ']');
		var $filterHead = $filter.find('[' + DATA_FILTER_HEAD + ']');
		var $filterInput = $filterHead.find('[' + DATA_FILTER_INPUT + '=' + category + ']');
		var $filterSubindex = $filter.find('[' + DATA_FILTER_SUBFILTER + ']');
		var $subFilterInput = $filterSubindex.find('[' + DATA_FILTER_INDEX + '=' + index + ']');

		$filterInput.prop('checked', true).change();
		$subFilterInput.prop('checked', true).change();
	}

	function initFilter () {
		var $filter = $('[' + DATA_FILTER + ']');
		var $filterHead = $filter.find('[' + DATA_FILTER_HEAD + ']');
		var filterCategory = $filterHead.find('[' + DATA_FILTER_INPUT + ']' + checked).attr(DATA_FILTER_INPUT);
		var $filterSubfilter = $filter.find('[' + DATA_FILTER_SUBFILTER + '=' + filterCategory + ']');
		var filterIndex = $filterSubfilter.find('[' + DATA_FILTER_INPUT + ']' + checked).attr(DATA_FILTER_INDEX);

		setFilter(filterCategory, filterIndex);
	}

})(window, jQuery);